import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-label-dev',
  templateUrl: './label-dev.component.html',
  styleUrls: ['./label-dev.component.scss']
})
export class LabelDevComponent implements OnInit {

  version: string = environment.VERSION;

  constructor() { }

  ngOnInit(): void {
  }

}
